export const DEFAULT_WIDGET_HEADER_HEIGHT = 32;
